import React, { memo, useCallback, useContext } from "react";

// core-ui components
import { LottieAnimation, HEADER_LOTTIE_ASSETS } from "@swiggy-private/core-ui";

// utils
import { getCloudinaryUrl } from "@swiggy-private/js-utils";

// styled
import { OtgContainer } from "./styled";

// constants
import { lottieProps, OtgLottieFrames } from "./constants";
import { CART_HEADER_DATA_TEST_IDS } from "@swiggy-private/cart-test-ids";
import { CartOverlaysContext } from "@swiggy-private/checkout-core";
import { LottieIds } from "@swiggy-private/cart-types";
export interface IOtgLottieProps {
    showOtgLottie: boolean;
    setOtgLottieShown: React.Dispatch<React.SetStateAction<boolean>>;
    showFinalState?: boolean;
}

const OtgLottie = ({ showOtgLottie, showFinalState, setOtgLottieShown }: IOtgLottieProps) => {
    const { onCloseOverlay, enabledOverlayId } = useContext(CartOverlaysContext);

    /**
     * Handles the completion of the OTG Lottie animation
     * - Closes the overlay if:
     *   - Not showing final state (animation is complete)
     *   - Current overlay is the cart header lottie
     *
     * @dependencies onCloseOverlay, showFinalState, enabledOverlayId
     */
    const onPlayComplete = useCallback(() => {
        setOtgLottieShown(true);
        if (!showFinalState && enabledOverlayId === LottieIds.CART_HEADER_LOTTIE) {
            onCloseOverlay();
        }
    }, [setOtgLottieShown, showFinalState, enabledOverlayId, onCloseOverlay]);

    if (!showOtgLottie) {
        return null;
    }

    return (
        <OtgContainer data-testId={CART_HEADER_DATA_TEST_IDS.OTG_LOTTIE}>
            <LottieAnimation
                {...lottieProps}
                fileName={getCloudinaryUrl(HEADER_LOTTIE_ASSETS.OTG_STAMP)}
                visible={showOtgLottie}
                playLottie={showOtgLottie}
                autoplay={showOtgLottie}
                frame={showFinalState ? { ...OtgLottieFrames, initial: OtgLottieFrames.final - 10 } : OtgLottieFrames}
                onPlayComplete={onPlayComplete}
            />
        </OtgContainer>
    );
};

export default memo(OtgLottie);
